/**
 * Checks if an option is selected by comparing it with selected members
 * @param {Object} option - The option to check
 * @param {Array} selectedMembers - Array of selected members
 * @returns {boolean} - True if the option is selected, false otherwise
 */
export const isOptionSelected = (option, selectedMembers) => {
  return selectedMembers.some(member => 
    (member.id && option.id && member.id === option.id) ||
    (member.username && option.username && member.username === option.username) ||
    (member.label === option.label)
  );
};

